import axios from 'axios'
import {
    REACT_APP_API
  } from '../../config'

export async function getSaleTypes(){  
    let results = ''
    try {
        results = await axios.get(`${REACT_APP_API}/saletypes`)
    } catch (error) {
        results = error.message
    }
    return results
}